import { Mixins as UiMixins } from 'truefuture-ui'

const Mixins = {
    ...UiMixins
}

export default Mixins